<template>
  <div :id="props.id">
    <div :id="`modalOverlay_${props.id}`" class="absolute inset-0 h-screen w-screen transition-all" 
      :class="[
        props.show ? 'backdrop-filter backdrop-blur-sm z-40' : 'backdrop-filter-none backdrop-blur-none hidden -z-30'
      ]"
      @click="emit('close')"
    />
    <dialog :open="props.show"
      class="max-w-5xl max-h-96 inset-0 p-4 bg-gray-100 border rounded-md border-oekoprofitgruen ring-1 ring-inherit transition-all overflow-y-scroll"
      :class="[
        props.show ? 'opacity-100 z-50' : 'opacity-0 -z-30'
      ]"
    >
      <h2 class="text-lg font-medium text-center mb-2">{{ props.title }}</h2>
      <form method="dialog" class="flex flex-col items-center">
        <div v-html="props.content?.replaceAll('\n','<br>')" />
        <button type="button" v-if="!props.isConfirmationDialog"
          id="modalClose"
          class="w-40 mt-4 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-oekoprofitgruen hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2"
          @click="emit('close')"
        >
          Schließen
        </button>
        <div v-else class="space-x-4">
          <button type="button"
            id="modalConfirm"
            class="w-40 mt-4 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-oekoprofitgruen hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2"
            @click="emit('confirm')"
          >
            Ja
          </button>
          <button type="button"
            id="modalCancel"
            class="w-40 mt-4 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-oekoprofitgruen hover:opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2"
            @click="emit('close')"
          >
            Nein
          </button>
        </div>
      </form>
    </dialog>
  </div>
</template>

<script setup lang="ts">
interface IModalProps {
  id?: string;
  show?: boolean;
  content?: string;
  title?: string;
  isConfirmationDialog?: boolean;
}

const props: IModalProps = defineProps<IModalProps>();

const emit = defineEmits<{
  (event: 'close') : void
  (event: 'confirm') : void
}>();
</script>
  